import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { FamilyWizardModel } from '../../models/family-wizard.model';

export interface TreatmentWizardSettingsState {
    shippingEnabled: number /** Indica si la company tiene activada el módulo de shiping. 0 Deshabilitado, -1 Opcional, -2 Obligatorio  */;
    shippingAddress: string /** La dirección de cliente (si la tiene configurada */;
    families: FamilyWizardModel[] /** Listado de familias disponibles para el asistente de compra */;
    stepStack: number[] /** Pila de pasos del asistente para volver hacia atrás */;
    cancelShippingUserChecked: boolean;
    confirmShippingUserChecked: boolean;
}

export function createInitialState(): TreatmentWizardSettingsState {
    return {
        shippingEnabled: 0,
        shippingAddress: '',
        families: [],
        stepStack: [],
        cancelShippingUserChecked: false,
        confirmShippingUserChecked: false,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'treatment-wizard-settings', resettable: true })
export class TreatmentWizardSettingsStore extends Store<
    TreatmentWizardSettingsState
> {
    constructor() {
        super(createInitialState());
    }
}
